var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.98356 7.37779C7.56355 8.58583 8.35425 9.718 9.3555 10.7193C10.3568 11.7207 11.4891 12.5113 12.6971 13.0913C12.801 13.1412 12.8529 13.1662 12.9187 13.1853C13.1523 13.2534 13.4392 13.2045 13.637 13.0628C13.6927 13.0229 13.7403 12.9753 13.8356 12.8801C14.1269 12.5887 14.2726 12.443 14.4191 12.3478C14.9715 11.9887 15.6837 11.9887 16.2361 12.3478C16.3826 12.443 16.5282 12.5887 16.8196 12.8801L16.9819 13.0424C17.4248 13.4853 17.6462 13.7068 17.7665 13.9446C18.0057 14.4175 18.0057 14.9761 17.7665 15.4491C17.6462 15.6868 17.4248 15.9083 16.9819 16.3512L16.8506 16.4825C16.4092 16.9239 16.1886 17.1446 15.8885 17.3131C15.5556 17.5001 15.0385 17.6346 14.6567 17.6334C14.3126 17.6324 14.0773 17.5657 13.607 17.4322C11.0792 16.7147 8.69383 15.361 6.70388 13.371C4.7139 11.381 3.36017 8.99567 2.6427 6.46787C2.50919 5.99749 2.44243 5.76231 2.44141 5.41818C2.44027 5.03633 2.57474 4.51926 2.76176 4.18633C2.9303 3.88631 3.15097 3.66563 3.59233 3.22427L3.72369 3.09292C4.16656 2.65005 4.388 2.42861 4.62581 2.30833C5.09878 2.0691 5.65733 2.0691 6.1303 2.30833C6.36811 2.42861 6.58955 2.65005 7.03242 3.09292L7.19481 3.25531C7.48615 3.54664 7.63182 3.69232 7.72706 3.83879C8.08622 4.39121 8.08622 5.10336 7.72706 5.65577C7.63182 5.80224 7.48615 5.94792 7.19481 6.23925C7.09955 6.33452 7.05192 6.38214 7.01205 6.43782C6.87038 6.63568 6.82146 6.92256 6.88956 7.15619C6.90873 7.22193 6.93367 7.27388 6.98356 7.37779Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.9419ec82d4047885911ce548c27c336e.svg";
export { ForwardRef as ReactComponent };